import { mode } from '@chakra-ui/theme-tools';

export const menuStyles = {
  components: {
    Menu: {
      baseStyle: (props) => ({
        button: {
          transition: '0.3s all',
          outline: 'unset',
          borderRadius: '10px',
          border: '1px solid rgba(255, 255, 255, 0.20)',
          position: 'relative',
          h: '44px',
          textAlign: 'center',
          'span > div': {
            position: 'relative',
            borderRadius: '9px'
          }
        },
        list: {
          color: mode('gray.800', 'white')(props),
          p: '12px 0px',
          borderRadius: '16px',
          borderWidth: '1px', 
          borderColor: mode('#2ABDFD', '#2ABDFD')(props),
          bg:  mode('#E0EAFF', '#0F1426')(props),
          boxShadow: mode('unset', '0px 1px 22px 0px rgba(9, 155, 255, 0.60)')(props),
          backdropFilter: 'blur(10px)',
          '> button': {
            p: '9px 26px',
            my: '3px',
            fontSize: '16px', 
            fontStyle: 'normal' ,
            fontWeight: '500',
            color: mode('blue.900', 'white')(props), 
            _focus: {
                bg: mode('white !important', '#0D234D !important')(props),
            },
            _active: {
                bg: mode('white !important', '#0D234D !important')(props),
            },
            _hover: {
              bg: mode('white !important', '#0D234D !important')(props),
            },
          },
          'div > button': {
            p: '9px 14px',
            my: '3px',
            fontSize: '14px', 
            fontStyle: 'normal' ,
            fontWeight: '400',
            color: mode('blue.900', 'white')(props), 
            _focus: {
                bg: mode('white !important', '#10337F !important')(props),
            },
            _active: {
                bg: mode('white !important', '#10337F !important')(props),
            },
            _hover: {
              bg: mode('white !important', '#10337F !important')(props),
            },
          },
        },
      }),
      variants: {
        wallet: (props) => ({
          button: {
            transition: '0.3s all',
            outline: 'unset',
            borderRadius: '10px',
            border: 'unset',
            position: 'relative',
            h: '44px',
            textAlign: 'center',
            'span > div': {
              position: 'relative',
              borderRadius: '10px',
              bg: mode(
                'linear-gradient(0deg, rgba(9, 155, 255, 0.17) 4.55%, rgba(255, 255, 255, 0.00) 100%), #EDF0FF',
                'linear-gradient(0deg, #29498F -69.32%, rgba(22, 43, 90, 0.30) 100%), #151A32')(props),
            },
            _hover: {
              borderRadius: '10px',
              'span > div': {
                bg: 'linear-gradient(16deg, rgba(22, 43, 90, 0.30) -13.5%, #29498F 85.98%), rgba(24, 112, 236, 0.05)'
              }
            },
            _active: {
              'span > div': {
                bg: 'linear-gradient(0deg, #29498F 0%, #29498F 100%), rgba(0, 78, 174, 0.10)'
              }
            }
          },
        }),
        account: (props) => ({
          button: {
            transition: '0.3s all',
            outline: 'unset',
            borderRadius: '10px',
            border: 'unset',
            position: 'relative',
            h: '44px',
            w: '44px',
            p: '0',
            textAlign: 'center',
            'span > div': {
              position: 'relative',
              borderRadius: '30px'
            }
          },
          list: {
            p: '24px 16px',
            w: '100%',
            'div > button': {
              p: '0',
              my: '0',
              fontSize: '14px', 
              fontStyle: 'normal' ,
              fontWeight: '400',
              color: mode('blue.900', 'white')(props), 
              borderRadius: '12px !important',
              _focus: {
                  bg: mode('white !important', '#0D234D !important')(props),
              },
              _active: {
                  bg: mode('white !important', '#0D234D !important')(props),
              },
              _hover: {
                bg: mode('white !important', '#0D234D !important')(props),
              },
              'a': {
                w: '100%',
                '&>div': {
                  p: '9px 14px',
                  my: '3px',
                }
              }
            },
          }
        }),
        sort: (props) => ({
          list: {
            p: '24px 16px',
            w: '100%',
            border: 'unset',
            boxShadow: 'unset',
            bg: mode('white', 'rgb(13, 35, 77)')(props),
            'div > button': {
              p: '0',
              my: '0',
              fontSize: '14px', 
              fontStyle: 'normal' ,
              fontWeight: '400',
              color: mode('blue.900', 'white')(props), 
              borderRadius: '12px !important',
              _focus: {
                  bg: mode('white !important', '#0D234D !important')(props),
              },
              _active: {
                  bg: mode('white !important', '#0D234D !important')(props),
              },
              _hover: {
                bg: mode('white !important', '#0D234D !important')(props),
              },
              'a': {
                w: '100%',
                '&>div': {
                  p: '9px 14px',
                  my: '3px',
                }
              }
            },
          }
        }),
        notifications: (props) => ({
          button: {
            transition: '0.3s all',
            outline: 'unset',
            borderRadius: '16px',
            bg: mode('white','#0E1633')(props),
            border: 'unset',
            position: 'relative',
            h: '44px',
            padding: '10px',
            textAlign: 'center',
            '.new-notifications': {
              position: 'absolute',
              bg: '#099BFF',
              border: mode('2px solid white', '2px solid #0E1633')(props),
              borderRadius: 'full', 
              w: '12px',
              h: '12px',
              top: '4px',
              right: '4px' 
            },
            _hover: {
              bg: mode('#ffffffbd !important', '#0D234D !important')(props),
            },
            _active: {
              bg: mode('white !important', '#0D234D !important')(props),
            },
            _focus: {
              outline: 'unset',
              boxShadow: 'unset',
            }
          },
          list: {
            p: '16px'
          }
        }),
        filter: (props) => ({
          button: {
            transition: '0.3s all',
            outline: 'unset',
            borderRadius: '10px',
            border: '1px solid rgba(255, 255, 255, 0.20)',
            position: 'relative',
            h: '44px',
            textAlign: 'center',
            'span > div': {
              position: 'relative',
              borderRadius: '9px',
              bg: mode(
                'linear-gradient(0deg, rgba(9, 155, 255, 0.17) 4.55%, rgba(255, 255, 255, 0.00) 100%), #EDF0FF',
                'linear-gradient(17deg, #29498F 12.16%, rgba(22, 43, 90, 0.30) 119.99%), #151A32')(props),
            },
            _hover: {
              'span > div': {
                bg: 'linear-gradient(16deg, rgba(22, 43, 90, 0.30) -13.5%, #29498F 85.98%), rgba(24, 112, 236, 0.05)'
              }
            },
            _active: {
              borderColor: 'rgba(255, 255, 255, 0.10)',
              'span > div': {
                bg: '#0279CB',
                'svg > path': {
                  fill: 'white'
                }
              }
            }
          },
        }),
        ghost: (props) => ({
          button: {
            transition: '0.3s all',
            border: 'unset',
            outline: 'unset',
            'span > div': {
              bg: 'unset',
              'p': {
                transition: '0.3s all',
                color: mode('blue.800', '#9FABCB')(props),
                fontWeight: '600',
                fontSize: '16px'
              },
              'svg': {
                mt: '0px',
                ml: '6px',
                'path': {
                  transition: '0.3s all',
                  stroke:  mode('blue.800', '#9FABCB')(props), 
                }
              }
            },
            _hover: {
              border: 'unset',
              'span > div': {
                bg: 'unset',
                'p': {
                  color: '#099BFF',
                },
                'svg': {
                  'path': {
                    stroke:  mode('blue.800', '#099BFF')(props), 
                  }
                }
              }
            },
            _active: {
              border: 'unset',
              'span > div': {
                bg: 'unset',
                'p': {
                  color: '#099BFF',
                },
                'svg': {
                  'path': {
                    stroke:  mode('blue.800', '#099BFF')(props), 
                  }
                }
              }
            }
          }
        }),
      },
    },
  },
};
